module.exports = __webpack_public_path__ + "static/media/boss_empty.6201f2f1.png";